import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getExecuteFlowTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'execute-flow',
			selector: '[data-tour="execute-flow"]',
			content: 'Required: This is used to select which flow the execute flow node should use.',
		},
		{
			id: 'execute-flow-version',
			selector: '[data-tour="execute-flow-version"]',
			content: 'Required: This is used to select which flow version to make use of.',
		},
		{
			id: 'destination-mappings',
			selector: '[data-tour="destination-mappings"]',
			content:
				'These contain the destination dropdowns such as the default success, defaut failure, and any other potential destinations that might exist due to the configuration of the flow.',
		},
		{
			id: 'execute-flow-tasks',
			selector: '[data-tour="execute-flow-tasks"]',
			content:
				'This section contains the tasks that make up the flow to be executed. Opening the individual task tabs will allow the user to change task config, independantly of the original flow.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
